import { logError } from "../errors/logError";
import { mapData } from "../components/shared/map/mapData";

export async function fetchGetAuth(url) {
    try {
        const res = await fetch(url, {
            credentials: "include",
        });

        if (res && res.ok) {
            const resJson = await res.json();
            return resJson;
        }
        else {
            throw new Error(`faild to fetch json url: ${url} with status: ${res && res.status}`)
        }
    }
    catch (err) {
        console.log("error in fetch json", url, err);
    }
}

export async function fetchJson(url) {
    let notCacheNumber;
    let res;
    let link;
    try {
        notCacheNumber = Math.floor(new Date().getTime());
        link = `${url}?ver=${notCacheNumber}`
        res = await fetch(link)

        if (res && res.ok) {
            const resJson = await res.json();
            return resJson;
        }
        else {
            throw new Error(`failed to fetch json url: ${url} with status: ${res && res.status}`);
        }
    }
    catch (err) {
        console.log("error in fetch json", url, err);
        let text, json;
        if (res) {
            try {
                text = await res.text();
                json = await res.json();
            }
            catch (e) {

            }
        }
        const msg = `${err.message} status ${res?.status} link: ${link} text: ${text} json: ${json}`;
        logError({
            type: "fetch-json",
            error: msg,
            desc: msg
        });
    }
}

export async function postJson(url, data) {
    let res, resJson;
    try {
        res = await fetch(
            url, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: data && JSON.stringify(data)
        });

        if (res) {
            const text = await res.text();
            resJson = text ? JSON.parse(text) : {};
            return {
                status: res.status,
                body: resJson,
                ok: res.ok
            };
        }
        else {
            throw new Error(`status from api ${res.status}`)
        }
    }
    catch (err) {
        console.error("error in postJson", url, err);
        return {
            status: res?.status,
            body: resJson,
            ok: res?.ok
        };
    }

}

export const getClassByNum = (num) => {
    return ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט', 'י', 'יא', 'יב'][num - 1];
}

export const removeSlashes = (string) => {
    return string?.replace(/\//g, "")
}

export const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const calculateTotalScore = (object, scoreKey) => {
    return object ? Object.values(object).reduce((sum, item) => sum + (item[scoreKey] || 0), 0) : 0;
};

export const getUserSchoolProperty = (userDetails, property) => {
    if (!userDetails) return null;
    return userDetails.schools && userDetails.schools.length
        ? userDetails.schools[0][property]
        : userDetails.defaultSchool?.[property] ?? null;
};

export const getUserAllSchoolProperty = (userDetails, property) => {
    if (!userDetails) return null;
    return userDetails.schools ? userDetails.schools.map(s => s[property])
        : userDetails.defaultSchool?.[property] ? [userDetails.defaultSchool?.[property]] : null;
};

export const isKosherUser = (userDetails) => {
    const superVisions = getUserAllSchoolProperty(userDetails, 'supervisionId');
    return superVisions?.length && superVisions?.every(s => s === 3);
}
export const getUserAllClassesSchoolProperty = (userDetails, property) => {
    if (!userDetails) return null;
    return userDetails.schools ?
        userDetails.schools.filter(s => s.fromClass).map(s => s[property])
        :
        userDetails.defaultSchool?.[property] ? [userDetails.defaultSchool?.[property]] : null;
}

export const getMapContent = (user, userDetails) => {
    let mapContent = mapData.teacherElementary;

    if (user?.isstudent !== "Yes") {
        const teacherClasses = getAllSchoolsClassRange(userDetails);
        const hasElementaryClass = teacherClasses?.some(c => Number(c) >= 1 && Number(c) <= 6);
        const hasHighSchoolClass = teacherClasses?.some(c => Number(c) >= 7 && Number(c) <= 12);

        if (hasElementaryClass) {
            if (isKosherUser(userDetails))
                mapContent = mapData.kosherTeacherElementary;
            else
                mapContent = mapData.teacherElementary;
        }
        else if (hasHighSchoolClass) {
            if (isKosherUser(userDetails))
                mapContent = mapData.kosherTeacherHighSchool;
            else
                mapContent = mapData.teacherHighSchool;
        }
        else {
            if (isKosherUser(userDetails)) {
                mapContent = mapData.kosherTeacherElementary;
            }
            else {
                mapContent = mapData.teacherElementary;
            }
        }
    }
    else {
        if (isKosherUser(userDetails)) {
            if (user?.isstudent === "Yes") {
                mapContent = mapData.kosherHighSchoolStudent;
                if (parseInt(user.studentkita) < 7)
                    mapContent = mapData.kosherElementaryStudent;
            }
        }
        else {
            if (user?.isstudent === "Yes") {
                if (parseInt(user.studentkita) < 7)
                    mapContent = mapData.elementaryStudent;
                if (parseInt(user.studentkita) === 7)
                    mapContent = mapData.studentIn7thGrade;
                if (parseInt(user.studentkita) >= 8)
                    mapContent = mapData.highSchoolStudent;
            }
        }
    }

    return mapContent;
}

export const getClassRange = (from, to) => {
    const fromNum = parseInt(from, 10);
    const toNum = parseInt(to, 10);
    if (isNaN(fromNum) || isNaN(toNum)) return [];
    const range = [];
    for (let i = fromNum; i <= toNum; i++) {
        range.push(i.toString());
    }
    return range;
}

export const getAllSchoolsClassRange = (userDetails) => {
    if (!userDetails?.schools)
        return [];
    const allClasses = userDetails.schools
        .filter(school => school.fromClass && school.toClass)
        .flatMap(school => getClassRange(school.fromClass, school.toClass));
    return [...new Set(allClasses)];
}

export const elementaryStudentOrTeacher = (user, userDetails, isStudent) => {
    // אם תלמיד - בדוק אם בכיתה יסודית (1-6)
    if (isStudent) {
        const grade = parseInt(user.studentkita);
        return grade >= 1 && grade <= 6;
    }
    // אם מורה - בדוק אם יש לו כיתה כלשהי ביסודי (1-6)
    const teacherClasses = getAllSchoolsClassRange(userDetails);
    return teacherClasses?.some(c => Number(c) >= 1 && Number(c) <= 6);
}

export const getMyUserSchool = (userDetails) => {
    if (userDetails && userDetails["schools"] && userDetails["schools"].length > 0) {
        const schoolWithClasses = userDetails["schools"].filter(x => x.fromClass)
        if (schoolWithClasses.length > 0)
            return schoolWithClasses[0]
    }
}

